import { useTranslation } from "react-i18next";
import { useCapacitySelector } from "userful-chronos-common-store/dist/diagnostics";
import "./CapacityNotification.scss";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import CapacityPopup from "./CapacityPopup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faCheckCircle, faDiamondExclamation, faSealExclamation } from "@fortawesome/pro-solid-svg-icons";

const CapacityNotification = () => {
    const { t } = useTranslation();

    const currentCapacity = useCapacitySelector((state) => state.capacityStore.data);
    const getWarningClass = (): string => {
        if (currentCapacity.usageLevel === "USAGE_LEVEL_1") {
            return "normal";
        }
        if (currentCapacity.usageLevel === "USAGE_LEVEL_2") {
            return "warn";
        }
        return "error";
    };
    const getIcon = (): IconProp => {
        if (currentCapacity.usageLevel === "USAGE_LEVEL_1") {
            return faCheckCircle;
        }
        if (currentCapacity.usageLevel === "USAGE_LEVEL_2") {
            return faDiamondExclamation;
        }
        return faSealExclamation;
    };

    return (
        <OverlayTrigger
            trigger="click"
            rootClose
            overlay={
                <Tooltip>
                    <CapacityPopup currentCapacity={currentCapacity} />
                </Tooltip>
            }
            placement="bottom"
        >
            <div className={`capacityIcon ${getWarningClass()}`}>
                <FontAwesomeIcon icon={getIcon()} />
            </div>
        </OverlayTrigger>
    );
};

export default CapacityNotification;
